export const translations = {
  de: {
    seo: {
      home: {
        title: "Lidlink — Werbung auf den Geräten, die Menschen tragen",
        desc: "Physisches Ad-Netzwerk auf Laptops und Tablets: Unternehmen erreichen verifizierte Studierende nach Hochschule, Studienrichtung und Standort — mit Fotobeleg für jede Anbringung. Pilotphase in Kiel.",
      },
      brands: {
        title: "Für Brands — Zielgruppen physisch erreichen | Lidlink",
        desc: "Kampagnen auf den Laptops und Tablets verifizierter Studierender: Targeting nach Hochschule, Studienrichtung, Standort und Laufzeit. Angebot auf Anfrage.",
      },
      people: {
        title: "Für Studierende — Mit deinem Gerät verdienen | Lidlink",
        desc: "Registriere kostenlos deinen Laptop oder dein Tablet, entscheide frei über jede Kampagne und erhalte eine Vergütung nach erfolgreichem Abschluss.",
      },
      about: {
        title: "Über Lidlink — Das physische Device-Ad-Network",
        desc: "Lidlink verbindet Unternehmen mit Menschen, die ihre Geräte täglich öffentlich nutzen. Transparent, einwilligungsbasiert, mit Fotobeleg. Pilotphase in Kiel.",
      },
    },
    topbar: {
      network: "LIDLINK · PHYSICAL DEVICE AD NETWORK · PILOTPHASE KIEL",
    },
    nav: {
      network: "Netzwerk",
      brands: "Für Brands",
      people: "Für Teilnehmende",
      specs: "Spezifikationen",
      calculator: "Rechner",
      about: "Über uns",
      account: "Konto",
      login: "Log in",
      cta: "Kampagne anfragen →",
      register: "Gerät anmelden",
    },
    hero: {
      eyebrow: "The Physical Device Ad Network",
      headline: "Werbung auf echten Geräten.",
      sub: "Erreiche verifizierte Studierende dort, wo digitale Anzeigen nicht hinkommen: auf den Geräten, die sie täglich in Universität, Bibliothek und Café nutzen.",
      ctaBrand: "Kampagne anfragen (Brands)",
      ctaPeople: "Gerät registrieren & verdienen",
      factPilot: "Pilotphase",
      factPilotValue: "Start in Kiel",
      factDevices: "Geräte",
      factDevicesValue: "Laptop & Tablet",
      factPay: "Vergütung",
      factPayValue: "Transparent pro Kampagne",
      imageCaption: "Studierende arbeiten täglich mit ihren Geräten in Bibliotheken und Cafés (Symbolbild).",
      imageCaptionConcept: "Konzeptvisualisierung — Beispielmotiv, kein Foto einer realen Kampagne.",
      imageAlt: "Studierende arbeiten in einer Bibliothek an Laptops",
    },
    targetline: "Targeting nach Hochschule. Studienrichtung. Standort. Gerät. Laufzeit.",
    how: {
      eyebrow: "So funktioniert es",
      title: "Vom Kampagnen-Targeting zum echten Sichtkontakt.",
      sub: "Ein transparentes System zwischen Unternehmen und Menschen, die ihre Geräte täglich öffentlich nutzen.",
      brandsTitle: "FÜR UNTERNEHMEN",
      brandSteps: [
        { t: "Zielgruppe definieren", d: "Standort, Hochschule, Studienrichtung, Gerätetyp, Anzahl und Laufzeit wählen — Angebot auf Anfrage." },
        { t: "Kampagne starten", d: "Lidlink produziert die Kampagnenfolien und sendet sie an passende, zustimmende Teilnehmende." },
        { t: "Anbringung per Fotobeleg", d: "Teilnehmende laden ein Foto der angebrachten Folie hoch; Lidlink bestätigt jede Platzierung." },
        { t: "Nachweise & Abschluss", d: "Du erhältst Fotobelege, bestätigte Platzierungen, geplante Placement Days und die Abschlussquote." },
      ],
      peopleTitle: "FÜR TEILNEHMENDE",
      peopleSteps: [
        { t: "Gerät kostenlos registrieren", d: "Laptop oder Tablet eintragen: Modell, Hochschule, Studienrichtung und typische Nutzungsorte." },
        { t: "Einladungen erhalten", d: "Passt eine Kampagne zu deinem Profil, melden wir uns. Eine Registrierung garantiert keine Auswahl." },
        { t: "Frei entscheiden", d: "Du stimmst jeder Kampagne einzeln zu — nachdem du Marke, Motiv, Laufzeit und Vergütung gesehen hast." },
        { t: "Anbringen & belegen", d: "Folie anbringen und die Installation per Foto nachweisen." },
        { t: "Vergütung erhalten", d: "Die Auszahlung erfolgt nach erfolgreichem Abschluss der Kampagne." },
      ],
      honesty: "Die Registrierung ist kostenlos und unverbindlich. Sie garantiert keine Auswahl für eine Kampagne. Eine Vergütung gibt es nur, wenn du für eine bezahlte Kampagne ausgewählt wirst, ihr freiwillig zustimmst und sie erfolgreich abschließt.",
    },
    specs: {
      eyebrow: "Material & Anforderungen",
      title: "Hochwertige Folien — geprüft vor jeder Kampagne.",
      sub: "Das Material befindet sich aktuell in der Lieferantenauswahl. Unsere Anforderung ist fest definiert: rückstandsfrei ablösbare Folien in hochwertiger Verarbeitung. Material und Oberfläche werden vor jeder Kampagne mit den Teilnehmenden abgestimmt.",
      cards: [
        { label: "FORMAT", value: "ca. 18 × 11 cm", sub: "Je nach Gerät angepasst" },
        { label: "ANFORDERUNG", value: "Rückstandsfrei ablösbar", sub: "Festes Kriterium der Materialauswahl" },
        { label: "OBERFLÄCHE", value: "Matt, hochwertig", sub: "Prüfung vor jeder Kampagne" },
        { label: "GERÄTE", value: "Laptop & Tablet", sub: "Sichtbare Rückseite, z. B. iPad mit Tastatur" },
      ],
      imageCaption: "Die Folie deckt nur einen Teil des Deckels ab — das Gerät bleibt erkennbar.",
      promiseLabel: "Unser Anspruch",
      promise: "Niemand trägt freiwillig eine minderwertige Folie auf einem teuren Gerät. Deshalb prüfen wir Material und Verarbeitung, bevor eine Kampagne startet.",
      imageAlt: "Laptop von hinten auf einem Tisch",
    },
    calc: {
      eyebrow: "Campaign Builder",
      title: "Baue deine Zielgruppe.",
      sub: "Konfiguriere deine physische Kampagne in wenigen Schritten. Du erhältst ein individuelles Angebot — Preise auf Anfrage.",
      location: "STANDORT",
      university: "HOCHSCHULE",
      field: "STUDIENRICHTUNG",
      device: "GERÄT",
      placements: "ANZAHL PLATZIERUNGEN",
      duration: "LAUFZEIT",
      locations: ["Kiel", "Hamburg (in Vorbereitung)", "Berlin (in Vorbereitung)"],
      universities: ["Alle Hochschulen am Standort", "CAU Kiel", "HAW Kiel", "Muthesius Kunsthochschule"],
      fields: ["Alle Studienrichtungen", "Ingenieurwissenschaften", "Wirtschaftswissenschaften", "Informatik & Data Science", "Rechtswissenschaften", "Medizin & Life Sciences", "Sonstige"],
      devices: ["Laptop", "Tablet", "Beides"],
      placementOptions: [25, 50, 100],
      placementSuffix: "Geräte",
      durationOptions: [
        { weeks: 2, label: "2 Wochen" },
        { weeks: 4, label: "4 Wochen" },
        { weeks: 8, label: "8 Wochen" },
      ],
      includedTitle: "INKLUSIVE:",
      included: [
        "Folienproduktion & Versand an Teilnehmende",
        "Fotobeleg jeder einzelnen Anbringung",
        "Kampagnenabschluss mit bestätigten Platzierungen",
        "Optional: QR-/Landingpage-Auswertung",
      ],
      estimateLabel: "DEINE KONFIGURATION",
      devicesUnit: "Geräte",
      weeksUnit: "Wochen",
      placementDays: "Geplante Placement Days",
      placementDaysHint: "Geräte × Tage (Planwert, keine Impressionen)",
      daysUnit: "Tage",
      audience: "Zielgruppe:",
      verification: "Nachweis:",
      verificationValue: "Fotobeleg je Anbringung",
      pricingLabel: "PREIS",
      pricingValue: "Angebot auf Anfrage",
      pricingHint: "Individuell nach Konfiguration, Auslastung und Material.",
      cta: "Diese Kampagne anfragen →",
    },
    register: {
      eyebrow: "Für Teilnehmende",
      title: "Dein Gerät ist ohnehin überall dabei. Lass es verdienen.",
      sub: "Registriere deinen Laptop oder dein Tablet kostenlos und unverbindlich. Du stimmst jeder Kampagne einzeln zu.",
      step: "SCHRITT",
      of: "VON",
      steps: ["Kontakt", "Studium", "Gerät", "Nutzungsorte", "Bestätigung"],
      name: "VOR- UND NACHNAME",
      namePh: "z. B. Jan Petersen",
      email: "E-MAIL",
      emailPh: "name@beispiel.de",
      password: "PASSWORT",
      passwordPh: "Mindestens 8 Zeichen",
      passwordHint: "Damit erstellst du dein Lidlink-Konto (Guthaben & Empfehlungen).",
      university: "HOCHSCHULE",
      universities: ["CAU Kiel", "HAW Kiel", "Muthesius Kunsthochschule", "Andere Hochschule"],
      studyProgram: "STUDIENRICHTUNG",
      studyProgramPh: "z. B. Informatik B.Sc.",
      semester: "SEMESTER",
      semesterPh: "z. B. 4. Fachsemester",
      deviceType: "GERÄTETYP",
      deviceTypeHint: "Mehrfachauswahl möglich — wähle Laptop und/oder iPad.",
      deviceTypes: ["Laptop / MacBook", "Tablet / iPad"],
      deviceModel: "GERÄTEMODELL",
      deviceModelPh: "z. B. MacBook Pro 14 Zoll / iPad Pro / Surface",
      usage: "WO NUTZT DU DEIN GERÄT ÖFFENTLICH?",
      usageOptions: ["Universität", "Bibliothek", "Büro", "Coworking", "Café", "Kundenmeetings", "Veranstaltungen"],
      declined: "KATEGORIEN AUSSCHLIESSEN (OPTIONAL)",
      declinedSub: "Du erhältst niemals Kampagnen aus diesen Bereichen.",
      declinedOptions: ["Alkohol", "Glücksspiel", "Politik", "Crypto", "Dating"],
      back: "Zurück",
      next: "Weiter →",
      submit: "GERÄT KOSTENLOS ANMELDEN →",
      note: "Kostenlos · Keine Auswahlgarantie · Zustimmung je Kampagne",
      successTitle: "Du bist im Lidlink-Netzwerk.",
      successSub: "Wir melden uns, sobald eine passende Kampagne verfügbar ist. Du entscheidest dann über jede Anfrage selbst.",
      errorDuplicate: "Diese E-Mail ist bereits registriert.",
      errorGeneric: "Etwas ist schiefgegangen. Bitte versuche es erneut.",
      required: "Bitte fülle alle Pflichtfelder aus.",
      fieldRequired: "Pflichtfeld",
      invalidEmail: "Ungültige E-Mail-Adresse",
      passwordShort: "Mindestens 8 Zeichen",
    },
    credit: {
      launchBadge: "Launch-Angebot: 5 € Startguthaben",
      benefitEyebrow: "Launch-Bonus",
      benefitTitle: "Starte mit bis zu 10 € Lidlink-Guthaben.",
      card1Title: "5 € Startguthaben",
      card1Text: "Registriere dich kostenlos. Das Guthaben wird mit deiner ersten erfolgreich abgeschlossenen Kampagne ausgezahlt.",
      card2Title: "+ 5 € Empfehlungsbonus",
      card2Text: "Lade 3 Freunde ein, die sich erfolgreich und gültig registrieren.",
      disclaimer: "Guthaben ist nicht sofort auszahlbar. Eine Registrierung garantiert keine Kampagne. Die Auszahlung erfolgt zusammen mit einer erfolgreich abgeschlossenen bezahlten Kampagne.",
      exampleTitle: "Beispielrechnung",
      exampleCampaign: "Kampagnenvergütung",
      exampleWelcome: "Startguthaben",
      exampleReferral: "Empfehlungsbonus",
      exampleTotal: "Gesamtauszahlung",
      exampleNote: "Beispiel — nicht jede Kampagne vergütet 20 €. Die Vergütung wird pro Kampagne festgelegt.",
      successTitle: "Du bist dabei.",
      successCredit: "5 € Startguthaben gutgeschrieben.",
      successSub: "Dein Guthaben wird zusammen mit deiner ersten erfolgreich abgeschlossenen bezahlten Kampagne ausgezahlt.",
      verifyNotice: "Wir haben dir eine E-Mail geschickt. Bitte bestätige deine E-Mail-Adresse, damit deine Empfehlungen zählen.",
      inviteTitle: "Lade 3 Freunde ein. Verdiene weitere 5 €.",
      yourLink: "Dein persönlicher Empfehlungslink",
      copyLink: "Link kopieren",
      copied: "Kopiert!",
      shareWhatsapp: "Über WhatsApp teilen",      whatsappMessage: "Ich nutze Lidlink — verdien mit deinem Laptop oder Tablet. Registriere dich über meinen Link:",
      showQr: "QR-Code anzeigen",
      hideQr: "QR-Code ausblenden",
      qrHint: "Zum Scannen — ideal zum Teilen auf dem Campus.",
      openWallet: "Zu meinem Konto →",
      walletTitle: "Mein Lidlink-Konto",
      walletCredit: "Lidlink-Guthaben",
      pending: "Ausstehend",
      paid: "Ausgezahlt",
      welcomeCredit: "Startguthaben",
      referralCredit: "Empfehlungsbonus",
      referralsProgress: "von 3 Freunden registriert",
      referralUnlocked: "Empfehlungsbonus freigeschaltet",
      notWithdrawable: "Ausstehendes Guthaben ist kein sofort auszahlbares Bargeld. Die Auszahlung erfolgt zusammen mit deiner ersten erfolgreich abgeschlossenen bezahlten Kampagne.",
      emailVerified: "E-Mail bestätigt",
      emailUnverified: "E-Mail nicht bestätigt",
      resendVerification: "Bestätigungs-E-Mail erneut senden",
      resent: "E-Mail gesendet.",
      resendError: "Senden fehlgeschlagen. Bitte später erneut versuchen.",
      deviceLabel: "Gerät",
      campaignStatus: "Kampagnenstatus",
      logout: "Abmelden",
      proofLink: "Installations-Nachweis öffnen",
      loginTitle: "Login",
      loginSub: "Für Teilnehmende — melde dich mit deiner E-Mail und deinem Passwort an.",
      loginEmail: "E-MAIL",
      loginPassword: "PASSWORT",
      loginSubmit: "ANMELDEN",
      loginError: "Anmeldung fehlgeschlagen. Bitte prüfe deine Zugangsdaten.",
      noAccount: "Noch kein Konto? Gerät registrieren",
      notRegisteredYet: "Noch nicht registriert?",
      registerCta: "Jetzt Gerät registrieren",
      forgotLink: "Passwort vergessen?",
      resetReqTitle: "Passwort zurücksetzen",
      resetReqSub: "Gib deine E-Mail ein — wir senden dir einen Link zum Zurücksetzen.",
      resetSend: "LINK SENDEN",
      resetSent: "Falls ein Konto existiert, haben wir dir einen Link geschickt.",
      resetNewTitle: "Neues Passwort",
      resetNewSub: "Wähle ein neues Passwort für dein Lidlink-Konto.",
      resetNewPassword: "NEUES PASSWORT",
      resetSet: "PASSWORT SPEICHERN",
      resetSuccess: "Passwort geändert.",
      resetSuccessSub: "Du kannst dich jetzt mit deinem neuen Passwort anmelden.",
      resetInvalid: "Dieser Link ist ungültig oder abgelaufen.",
      resetToLogin: "Zum Login →",
      haveAccount: "Bereits registriert? Anmelden",
      verifyTitle: "E-Mail wird bestätigt …",
      verifySuccess: "E-Mail bestätigt. Danke!",
      verifySuccessSub: "Dein Konto ist jetzt vollständig aktiviert.",
      verifyError: "Dieser Bestätigungslink ist ungültig oder abgelaufen.",
      verifyGoWallet: "Zu meinem Konto →",
      loading: "Lädt …",
      leaderboardTitle: "Empfehlungs-Bestenliste",
      leaderboardSub: "Deine erfolgreichen Einladungen im Vergleich.",
      yourRank: "Dein Rang",
      invitesLabel: "Einladungen",
      you: "Du",
      noReferralsYet: "Noch keine gültigen Empfehlungen — lade Freunde ein und klettere nach oben.",
    },
    proof: {
      label: "Transparenz statt Versprechen",
      title: "Werde Teil des ersten Lidlink-Netzwerks.",
      text: "Wir zeigen keine erfundenen Reichweiten oder Fantasiezahlen. Jede Anbringung wird per Fotobeleg dokumentiert — das ist unser Nachweis, keine geschätzten Impressionen.",
      badge1: "PILOTPHASE KIEL",
      badge2: "FOTOBELEG FÜR JEDE ANBRINGUNG",
    },
    faq: {
      eyebrow: "Fragen & Antworten",
      title: "Häufige Fragen zu Lidlink",
      items: [
        { q: "Wie viel kann ich verdienen?", a: "Die Vergütung hängt von Kampagne, Laufzeit und Gerät ab. Du siehst den genauen Betrag immer, bevor du einer Kampagne zustimmst. Eine Auszahlung erfolgt erst nach erfolgreichem Abschluss." },
        { q: "Muss ich jede Kampagne annehmen?", a: "Nein. Du stimmst jeder Kampagne freiwillig und einzeln zu — nachdem du Marke, Motiv, Laufzeit und Vergütung gesehen hast. Kategorien wie Glücksspiel, Alkohol oder Politik kannst du dauerhaft ausschließen." },
        { q: "Beschädigt die Folie mein Gerät?", a: "Unsere Anforderung an das Material: rückstandsfrei ablösbare Folie. Material und Oberfläche prüfen wir vor jeder Kampagne, und die Entfernung erfolgt nach Anleitung. Eine absolute Garantie können wir ehrlicherweise nicht geben — bei Fragen zu deinem konkreten Gerät melde dich vorab bei uns." },
        { q: "Kann ich ein iPad oder Tablet registrieren?", a: "Ja — Laptop und Tablet werden gleichermaßen unterstützt. Voraussetzung: Die Rückseite ist während der Nutzung sichtbar, z. B. beim iPad mit Tastatur oder Ständer." },
        { q: "Wann werde ich bezahlt?", a: "Die Auszahlung erfolgt nach erfolgreichem Abschluss der Kampagne entsprechend der Kampagnenbedingungen — in der Regel nach Ende der Laufzeit und bestätigtem Fotobeleg." },
        { q: "Garantiert die Registrierung eine Kampagne?", a: "Nein. Die Registrierung ist kostenlos und unverbindlich, garantiert aber keine Auswahl. Wir melden uns, sobald eine Kampagne zu deinem Profil passt." },
        { q: "Was kostet eine Kampagne für Unternehmen?", a: "Der Preis hängt von Konfiguration, Auslastung und Material ab. Du erhältst nach deiner Anfrage ein individuelles Angebot." },
        { q: "Wie können Unternehmen die Zielgruppe auswählen?", a: "Nach Standort, Hochschule, Studienrichtung, Gerätetyp, Anzahl und Laufzeit — soweit entsprechende Teilnehmende im Netzwerk registriert sind." },
        { q: "Bekomme ich die 5 € direkt ausgezahlt?", a: "Nein. Die 5 € werden zunächst als Lidlink-Guthaben hinterlegt und zusammen mit deiner ersten erfolgreich abgeschlossenen bezahlten Kampagne ausgezahlt." },
        { q: "Wie funktioniert der Empfehlungsbonus?", a: "Nach deiner Registrierung erhältst du einen persönlichen Empfehlungslink. Registrieren sich 3 gültige neue Teilnehmer über deinen Link, erhältst du zusätzlich 5 € Lidlink-Guthaben." },
        { q: "Bekomme ich automatisch eine Kampagne, wenn ich mich registriere?", a: "Nein. Die Registrierung macht dich für passende Kampagnen verfügbar, garantiert aber weder eine Auswahl noch eine Auszahlung." },
        { q: "Was passiert, wenn ich noch keine Kampagne bekommen habe?", a: "Dein berechtigtes Guthaben bleibt als ausstehendes Lidlink-Guthaben in deinem Account gespeichert und wird erst bei einer erfolgreich abgeschlossenen Kampagne ausgezahlt." },
      ],
    },
    contact: {
      eyebrow: "Kampagnenanfrage",
      title: "Starte deine erste Lidlink-Kampagne",
      sub: "Erreiche Studierende dort, wo digitale Anzeigen nicht hinkommen. Beschreibe dein Vorhaben — wir melden uns persönlich bei dir.",
      company: "UNTERNEHMEN / MARKE",
      companyPh: "z. B. Muster GmbH",
      person: "ANSPRECHPARTNER",
      personPh: "Name, Position",
      email: "GESCHÄFTLICHE E-MAIL",
      emailPh: "kontakt@unternehmen.de",
      quota: "GEWÜNSCHTE KONFIGURATION",
      quotaPh: "z. B. 50 Geräte, CAU Kiel, Ingenieurwissenschaften, 4 Wochen",
      message: "NACHRICHT / KAMPAGNENFOKUS",
      messagePh: "Recruiting, Employer Branding oder Produktlaunch …",
      note: "Unverbindliche Anfrage · Individuelles Angebot",
      submit: "KAMPAGNENANFRAGE ABSENDEN",
      sending: "WIRD GESENDET …",
      successTitle: "Anfrage erhalten.",
      successSub: "Vielen Dank. Wir prüfen deine Konfiguration und melden uns mit einem individuellen Angebot bei dir. Eine Eingangsbestätigung haben wir dir per E-Mail geschickt.",
      errorGeneric: "Etwas ist schiefgegangen. Bitte versuche es erneut.",
      required: "Bitte fülle alle Pflichtfelder aus.",
      fieldRequired: "Pflichtfeld",
      invalidEmail: "Ungültige E-Mail-Adresse",
    },
    consent: {
      text: "Wir verwenden technisch notwendige Cookies sowie Dienste (u. a. Cloudflare, Hosting), die Cookies setzen können. Optionale Cookies nur mit deiner Einwilligung.",
      accept: "Akzeptieren",
      reject: "Ablehnen",
      learn: "Datenschutz",
    },
    footer: {
      tagline: "Werbung auf den Geräten, die Menschen tragen.",
      platform: "Plattform",
      platformLinks: ["So funktioniert es", "Rechner", "Spezifikationen"],
      brands: "Brands",
      brandsLinks: ["Für Brands", "Zielgruppen", "Kampagne anfragen"],
      people: "Teilnehmende",
      peopleLinks: ["Registrierung", "Vergütung", "Kampagnen-Regeln"],
      company: "Unternehmen",
      companyLinks: ["Über Lidlink", "Kontakt"],
      legal: "Rechtliches",
      legalLinks: ["Impressum", "Datenschutz", "AGB", "Cookie-Hinweise"],
      bottom: "Lidlink · Pilotphase Kiel",
    },
    brandsPage: {
      eyebrow: "Für Brands",
      title: "Erreiche Menschen an Orten, die digitale Ads nicht besitzen können.",
      sub: "Lidlink platziert deine Marke auf den Laptops und Tablets verifizierter Studierender — sichtbar in Hörsälen, Bibliotheken, Cafés und Coworking-Spaces.",
      cta: "Kampagne anfragen →",
      imageAlt: "Laptop in einem Café mit Gästen im Hintergrund",
      imageCaption: "In Cafés und Coworking-Spaces ist der Laptopdeckel für andere sichtbar (Symbolbild).",
      whyTitle: "Warum Unternehmen Lidlink nutzen",
      why: [
        { t: "Präzises Targeting", d: "Zielgruppen nach Standort, Hochschule, Studienrichtung, Gerät und Laufzeit — z. B. Studierende der Ingenieurwissenschaften an der CAU Kiel für 4 Wochen." },
        { t: "Physische Präsenz", d: "Deine Werbung existiert real im Alltag — nicht nur für Sekunden in einem Feed." },
        { t: "Belegte Platzierungen", d: "Jede Anbringung wird per Foto dokumentiert und von Lidlink bestätigt, bevor sie zur Kampagne zählt." },
        { t: "Nachvollziehbares Reporting", d: "Fotobelege, bestätigte Platzierungen, geplante Placement Days und Abschlussquote — keine geschätzten Impressionen." },
      ],
      usecasesTitle: "Einsatzszenarien",
      usecasesNote: "Jede Kampagne wird individuell mit dir konfiguriert — diese Szenarien zeigen typische Anwendungen.",
      usecases: [
        { t: "Employer Branding", d: "Erreiche Studierende bestimmter Fachrichtungen direkt auf dem Campus — z. B. Ingenieurwissenschaften in Kiel." },
        { t: "Recruiting", d: "Sprich Informatik- oder Wirtschafts-Studierende in ihrem Semesteralltag an." },
        { t: "Product Launches", d: "Platziere eine neue App oder Software gezielt bei Early Adoptern." },
        { t: "Lokale Kampagnen", d: "Erreiche als lokales Unternehmen gezielt bestimmte Hochschulen." },
        { t: "Events", d: "Kampagnen rund um Konferenzen, Hochschulmessen oder den Semesterstart." },
      ],
      measurementTitle: "Messung — nur was wir wirklich belegen",
      measurementNote: "Wir versprechen keine geschätzten Impressionen. Wir liefern Belege.",
      measurement: [
        { t: "Fotobelege", d: "Foto jeder angebrachten Folie, hochgeladen von den Teilnehmenden.", status: "Implementiert" },
        { t: "Bestätigte Platzierungen", d: "Jede Platzierung wird von Lidlink geprüft und bestätigt.", status: "Implementiert" },
        { t: "Placement Days", d: "Planwert: Geräte × Tage, z. B. 100 Geräte × 28 Tage = 2.800 geplante Placement Days.", status: "Implementiert" },
        { t: "Abschlussquote", d: "Anteil der Teilnehmenden, die die Kampagne vollständig abschließen.", status: "Implementiert" },
        { t: "QR-/Landingpage-Aktivität", d: "Scans und Besuche über kampagnenspezifische Codes und Links.", status: "Optional" },
        { t: "Promo-Codes", d: "Conversions über exklusive Codes der Kampagne.", status: "Optional" },
      ],
    },
    peoplePage: {
      eyebrow: "Für Teilnehmende",
      title: "Dein Gerät kann auch verdienen.",
      sub: "Registriere deinen Laptop oder dein Tablet kostenlos und erhalte Einladungen zu Kampagnen, die zu deinem Profil passen.",
      cta: "Gerät kostenlos registrieren →",
      controlTitle: "Du behältst die Kontrolle. Immer.",
      control: [
        { t: "Freiwillige Zustimmung je Kampagne", d: "Keine Kampagne ohne deine ausdrückliche, separate Zustimmung." },
        { t: "Kategorien ausschließbar", d: "Alkohol, Glücksspiel, Politik, Crypto, Dating — du legst fest, was nicht auf dein Gerät kommt." },
        { t: "Volle Transparenz vor Zustimmung", d: "Du siehst Marke, Motiv, Laufzeit, Vergütung und Anforderungen — erst dann entscheidest du." },
        { t: "Rückstandsfrei ablösbare Folie", d: "Unsere Materialanforderung, geprüft vor jeder Kampagne. Dein Gerät bleibt dein Gerät." },
      ],
      earningsTitle: "So funktioniert die Vergütung",
      earnings: "Die Registrierung ist kostenlos und garantiert keine Auswahl. Wirst du für eine Kampagne ausgewählt, stimmst du ihr freiwillig zu, bringst die Folie an, belegst die Installation per Foto und hältst die Laufzeit ein. Die Auszahlung erfolgt nach erfolgreichem Abschluss der Kampagne.",
      honesty: "Eine Registrierung garantiert keine Vergütung. Bezahlt wird nur die erfolgreich abgeschlossene, bezahlte Kampagne, der du zugestimmt hast.",
    },
    aboutPage: {
      eyebrow: "Über Lidlink",
      title: "Ein neues Werbemedium — auf den Geräten, die Menschen tragen.",
      intro: "Lidlink ist ein zweiseitiges Werbenetzwerk: Unternehmen buchen Kampagnen auf den Laptops und Tablets registrierter Teilnehmender. Teilnehmende tragen eine hochwertige Kampagnenfolie für die vereinbarte Laufzeit und erhalten nach erfolgreichem Abschluss eine Vergütung.",
      pilotTitle: "Pilotphase in Kiel",
      pilotText: "Wir starten bewusst klein und lokal: Der Startfokus liegt auf Studierenden in Kiel, weil sich dort Zielgruppen nach Hochschule, Studienrichtung und Standort präzise zusammenstellen lassen. Weitere Standorte folgen, sobald der Pilot stabil läuft.",
      principlesTitle: "Unsere Grundsätze",
      principles: [
        { t: "Transparenz", d: "Keine erfundenen Zahlen, keine geschätzten Impressionen. Wir zeigen, was wir belegen können." },
        { t: "Einwilligung", d: "Teilnehmende stimmen jeder Kampagne einzeln und freiwillig zu — mit voller Information vorab." },
        { t: "Ehrliche Vergütung", d: "Die Registrierung ist kostenlos und garantiert keine Auswahl. Vergütet wird der erfolgreiche Kampagnenabschluss." },
        { t: "Werthaltiges Material", d: "Rückstandsfrei ablösbare Folie als feste Anforderung; Material und Oberfläche werden vor jeder Kampagne geprüft." },
      ],
      contactTitle: "Kontakt",
      contactText: "Fragen zur Plattform, zu Kampagnen oder zur Teilnahme? Schreib uns über das Formular — wir melden uns persönlich.",
      contactCta: "Kontakt aufnehmen →",
      legalNote: "Anbieterkennzeichnung und rechtliche Details findest du im Impressum.",
    },
    proofPage: {
      eyebrow: "INSTALLATIONS-NACHWEIS",
      title: "Bestätige deine Anbringung",
      hi: "Hi",
      intro: "Lade ein Foto deines Geräts mit angebrachter Kampagnenfolie hoch — Deckel und Folie gut sichtbar.",
      device: "GERÄT",
      statusLabel: "KAMPAGNENSTATUS",
      uploadLabel: "FOTO AUSWÄHLEN ODER AUFNEHMEN",
      uploadHint: "JPEG, PNG oder WebP · max. 10 MB",
      submit: "NACHWEIS HOCHLADEN →",
      uploading: "WIRD HOCHGELADEN …",
      successTitle: "Nachweis erhalten.",
      successSub: "Wir prüfen die Anbringung und bestätigen sie. Deine Vergütung folgt nach erfolgreichem Kampagnenende.",
      verifiedBadge: "✓ Anbringung verifiziert",
      pendingBadge: "Nachweis eingereicht — Prüfung läuft",
      alreadyTitle: "Dein Nachweis liegt bereits vor.",
      notFound: "Dieser Link ist ungültig oder abgelaufen.",
      errorGeneric: "Upload fehlgeschlagen. Bitte versuche es erneut.",
      errorType: "Bitte wähle eine Bilddatei (JPEG, PNG, WebP).",
      changePhoto: "Anderes Foto hochladen",
    },
    legal: {
      note: "Hinweis: Die rechtlichen Informationen werden auf Deutsch bereitgestellt. / Legal information is provided in German.",
      back: "← Zurück zur Startseite",
    },
    login: {
      title: "Admin Login",
      sub: "Zugang zur Lidlink-Verwaltung.",
      email: "E-MAIL",
      password: "PASSWORT",
      submit: "ANMELDEN",
      error: "Anmeldung fehlgeschlagen. Bitte prüfe deine Zugangsdaten.",
    },
    admin: {
      title: "Lidlink Admin",
      registrations: "Registrierungen",
      requests: "Kampagnenanfragen",
      logout: "Abmelden",
      empty: "Noch keine Einträge.",
      status: "Status",
      date: "Datum",
      loading: "Lade …",
    },
  },

  en: {
    seo: {
      home: {
        title: "Lidlink — Advertising on the devices people carry",
        desc: "The physical device ad network: brands reach verified students by university, field of study and location — with photo proof for every placement. Pilot phase in Kiel, Germany.",
      },
      brands: {
        title: "For Brands — Reach audiences physically | Lidlink",
        desc: "Campaigns on the laptops and tablets of verified students: targeting by university, field of study, location and duration. Pricing on request.",
      },
      people: {
        title: "For People — Earn with your device | Lidlink",
        desc: "Register your laptop or tablet for free, approve every campaign individually and get paid after successful completion.",
      },
      about: {
        title: "About Lidlink — The physical device ad network",
        desc: "Lidlink connects brands with people who use their devices in public every day. Transparent, consent-based, with photo proof. Pilot phase in Kiel.",
      },
    },
    topbar: {
      network: "LIDLINK · PHYSICAL DEVICE AD NETWORK · PILOT PHASE KIEL",
    },
    nav: {
      network: "Network",
      brands: "For Brands",
      people: "For People",
      specs: "Specifications",
      calculator: "Calculator",
      about: "About",
      account: "Account",
      login: "Log in",
      cta: "Request campaign →",
      register: "Register device",
    },
    hero: {
      eyebrow: "The Physical Device Ad Network",
      headline: "Put your brand where people work, study and create.",
      sub: "Reach verified students where digital ads can't go: on the devices they use every day in universities, libraries and cafés.",
      ctaBrand: "Advertise with Lidlink →",
      ctaPeople: "Earn with your device →",
      factPilot: "Pilot phase",
      factPilotValue: "Launching in Kiel",
      factDevices: "Devices",
      factDevicesValue: "Laptop & tablet",
      factPay: "Compensation",
      factPayValue: "Transparent per campaign",
      imageCaption: "Students work on their devices in libraries and cafés every day (stock photo).",
      imageCaptionConcept: "Concept visualisation — example artwork, not a photo of a real campaign.",
      imageAlt: "Students working on laptops in a library",
    },
    targetline: "Target by university. Field of study. Location. Device. Duration.",
    how: {
      eyebrow: "How it works",
      title: "From campaign targeting to real-world visibility.",
      sub: "A transparent system between brands and people who use their devices in public every day.",
      brandsTitle: "FOR BRANDS",
      brandSteps: [
        { t: "Define your audience", d: "Choose location, university, field of study, device type, quantity and duration — pricing on request." },
        { t: "Launch the campaign", d: "Lidlink produces the campaign skins and ships them to matching, consenting participants." },
        { t: "Photo proof of placement", d: "Participants upload a photo of the applied skin; Lidlink confirms every placement." },
        { t: "Proof & completion", d: "You receive photo evidence, confirmed placements, planned placement days and the completion rate." },
      ],
      peopleTitle: "FOR PARTICIPANTS",
      peopleSteps: [
        { t: "Register your device for free", d: "Enter your laptop or tablet: model, university, field of study and typical usage locations." },
        { t: "Receive invitations", d: "If a campaign matches your profile, we get in touch. Registration does not guarantee selection." },
        { t: "Decide freely", d: "You approve each campaign individually — after seeing brand, design, duration and compensation." },
        { t: "Apply & verify", d: "Apply the skin and prove the installation with a photo." },
        { t: "Get paid", d: "Payout follows after the successful completion of the campaign." },
      ],
      honesty: "Registration is free and non-binding. It does not guarantee selection for a campaign. Compensation is only paid when you are selected for a paid campaign, voluntarily accept it and complete it successfully.",
    },
    specs: {
      eyebrow: "Material & requirements",
      title: "Premium skins — checked before every campaign.",
      sub: "Material selection with suppliers is currently in progress. Our requirement is fixed: residue-free removable films in high-quality finishing. Material and surface are reviewed with participants before every campaign.",
      cards: [
        { label: "FORMAT", value: "approx. 18 × 11 cm", sub: "Adjusted to each device" },
        { label: "REQUIREMENT", value: "Residue-free removal", sub: "Fixed criterion of material selection" },
        { label: "SURFACE", value: "Matte, premium", sub: "Reviewed before every campaign" },
        { label: "DEVICES", value: "Laptop & tablet", sub: "Visible back, e.g. iPad with keyboard" },
      ],
      imageCaption: "The skin covers only part of the lid — the device stays recognisable.",
      promiseLabel: "Our standard",
      promise: "Nobody voluntarily carries a low-quality skin on an expensive device. That's why we review material and finishing before a campaign starts.",
      imageAlt: "Laptop from behind on a table",
    },
    calc: {
      eyebrow: "Campaign Builder",
      title: "Build your audience.",
      sub: "Configure your physical campaign in a few steps. You receive an individual quote — pricing on request.",
      location: "LOCATION",
      university: "UNIVERSITY",
      field: "FIELD OF STUDY",
      device: "DEVICE",
      placements: "NUMBER OF PLACEMENTS",
      duration: "DURATION",
      locations: ["Kiel", "Hamburg (in preparation)", "Berlin (in preparation)"],
      universities: ["All universities at location", "CAU Kiel", "HAW Kiel", "Muthesius University"],
      fields: ["All fields of study", "Engineering", "Business & Economics", "Computer Science & Data", "Law", "Medicine & Life Sciences", "Other"],
      devices: ["Laptop", "Tablet", "Both"],
      placementOptions: [25, 50, 100],
      placementSuffix: "devices",
      durationOptions: [
        { weeks: 2, label: "2 weeks" },
        { weeks: 4, label: "4 weeks" },
        { weeks: 8, label: "8 weeks" },
      ],
      includedTitle: "INCLUDED:",
      included: [
        "Skin production & shipping to participants",
        "Photo proof of every single placement",
        "Campaign completion with confirmed placements",
        "Optional: QR / landing page analytics",
      ],
      estimateLabel: "YOUR CONFIGURATION",
      devicesUnit: "devices",
      weeksUnit: "weeks",
      placementDays: "Planned placement days",
      placementDaysHint: "devices × days (planned value, not impressions)",
      daysUnit: "days",
      audience: "Audience:",
      verification: "Proof:",
      verificationValue: "Photo proof per placement",
      pricingLabel: "PRICING",
      pricingValue: "Quote on request",
      pricingHint: "Individual, based on configuration, availability and material.",
      cta: "Request this campaign →",
    },
    register: {
      eyebrow: "For participants",
      title: "Your device already goes everywhere with you. Make it earn.",
      sub: "Register your laptop or tablet free of charge and without obligation. You approve every campaign individually.",
      step: "STEP",
      of: "OF",
      steps: ["Contact", "Studies", "Device", "Usage", "Confirm"],
      name: "FULL NAME",
      namePh: "e.g. Jan Petersen",
      email: "EMAIL",
      emailPh: "name@example.com",
      password: "PASSWORD",
      passwordPh: "At least 8 characters",
      passwordHint: "This creates your Lidlink account (credit & referrals).",
      university: "UNIVERSITY",
      universities: ["CAU Kiel", "HAW Kiel", "Muthesius University", "Other university"],
      studyProgram: "FIELD OF STUDY",
      studyProgramPh: "e.g. Computer Science B.Sc.",
      semester: "SEMESTER",
      semesterPh: "e.g. 4th semester",
      deviceType: "DEVICE TYPE",
      deviceTypeHint: "Multiple selection possible — choose laptop and/or iPad.",
      deviceTypes: ["Laptop / MacBook", "Tablet / iPad"],
      deviceModel: "DEVICE MODEL",
      deviceModelPh: "e.g. MacBook Pro 14 inch / iPad Pro / Surface",
      usage: "WHERE DO YOU USE YOUR DEVICE IN PUBLIC?",
      usageOptions: ["University", "Library", "Office", "Coworking", "Café", "Client meetings", "Events"],
      declined: "EXCLUDE CATEGORIES (OPTIONAL)",
      declinedSub: "You will never receive campaigns from these categories.",
      declinedOptions: ["Alcohol", "Gambling", "Politics", "Crypto", "Dating"],
      back: "Back",
      next: "Next →",
      submit: "REGISTER DEVICE FOR FREE →",
      note: "Free · No selection guarantee · Consent per campaign",
      successTitle: "You're on the Lidlink network.",
      successSub: "We'll notify you when a matching campaign becomes available. You decide on every request yourself.",
      errorDuplicate: "This email is already registered.",
      errorGeneric: "Something went wrong. Please try again.",
      required: "Please fill in all required fields.",
      fieldRequired: "Required field",
      invalidEmail: "Invalid email address",
      passwordShort: "At least 8 characters",
    },
    credit: {
      launchBadge: "Launch offer: €5 Welcome Credit",
      benefitEyebrow: "Launch bonus",
      benefitTitle: "Start with up to €10 in Lidlink credit.",
      card1Title: "€5 Welcome Credit",
      card1Text: "Register for free. Your credit is paid out with your first successfully completed campaign.",
      card2Title: "+ €5 Referral Credit",
      card2Text: "Invite 3 friends who register successfully and validly.",
      disclaimer: "Credit is not immediately withdrawable. Registration does not guarantee a campaign. Payout happens together with a successfully completed paid campaign.",
      exampleTitle: "Example",
      exampleCampaign: "Campaign payment",
      exampleWelcome: "Welcome Credit",
      exampleReferral: "Referral Credit",
      exampleTotal: "Total payout",
      exampleNote: "Example — not every campaign pays €20. Compensation is set per campaign.",
      successTitle: "You're in.",
      successCredit: "€5 Welcome Credit added.",
      successSub: "Your credit will be paid out together with your first successfully completed paid campaign.",
      verifyNotice: "We've sent you an email. Please confirm your email address so your referrals count.",
      inviteTitle: "Invite 3 friends. Earn another €5.",
      yourLink: "Your personal referral link",
      copyLink: "Copy referral link",
      copied: "Copied!",
      shareWhatsapp: "Share on WhatsApp",
      whatsappMessage: "I'm using Lidlink — earn with your laptop or tablet. Register via my link:",
      showQr: "Show QR code",
      hideQr: "Hide QR code",
      qrHint: "For scanning — ideal for sharing on campus.",
      openWallet: "Go to my account →",
      walletTitle: "My Lidlink account",
      walletCredit: "Lidlink Credit",
      pending: "Pending",
      paid: "Paid",
      welcomeCredit: "Welcome Credit",
      referralCredit: "Referral Credit",
      referralsProgress: "of 3 friends registered",
      referralUnlocked: "Referral bonus unlocked",
      notWithdrawable: "Pending credit is not immediately available cash. Payout happens together with your first successfully completed paid campaign.",
      emailVerified: "Email verified",
      emailUnverified: "Email not verified",
      resendVerification: "Resend verification email",
      resent: "Email sent.",
      resendError: "Sending failed. Please try again later.",
      deviceLabel: "Device",
      campaignStatus: "Campaign status",
      logout: "Sign out",
      proofLink: "Open installation proof",
      loginTitle: "Login",
      loginSub: "For participants — sign in with your email and password.",
      loginEmail: "EMAIL",
      loginPassword: "PASSWORD",
      loginSubmit: "SIGN IN",
      loginError: "Login failed. Please check your credentials.",
      noAccount: "No account yet? Register your device",
      notRegisteredYet: "Not registered yet?",
      registerCta: "Register your device now",
      forgotLink: "Forgot password?",
      resetReqTitle: "Reset password",
      resetReqSub: "Enter your email — we'll send you a reset link.",
      resetSend: "SEND LINK",
      resetSent: "If an account exists, we've sent you a link.",
      resetNewTitle: "New password",
      resetNewSub: "Choose a new password for your Lidlink account.",
      resetNewPassword: "NEW PASSWORD",
      resetSet: "SAVE PASSWORD",
      resetSuccess: "Password changed.",
      resetSuccessSub: "You can now sign in with your new password.",
      resetInvalid: "This link is invalid or has expired.",
      resetToLogin: "To login →",
      haveAccount: "Already registered? Sign in",
      verifyTitle: "Verifying email …",
      verifySuccess: "Email verified. Thank you!",
      verifySuccessSub: "Your account is now fully activated.",
      verifyError: "This verification link is invalid or has expired.",
      verifyGoWallet: "Go to my account →",
      loading: "Loading …",
      leaderboardTitle: "Referral leaderboard",
      leaderboardSub: "Your successful invites compared.",
      yourRank: "Your rank",
      invitesLabel: "invites",
      you: "You",
      noReferralsYet: "No valid referrals yet — invite friends and climb the ranking.",
    },
    proof: {
      label: "Transparency over promises",
      title: "Join the first Lidlink network.",
      text: "We don't show invented reach or fantasy numbers. Every placement is documented with photo proof — that's our evidence, not estimated impressions.",
      badge1: "PILOT PHASE KIEL",
      badge2: "PHOTO PROOF FOR EVERY PLACEMENT",
    },
    faq: {
      eyebrow: "Questions & answers",
      title: "Frequently asked questions",
      items: [
        { q: "How much can I earn?", a: "Compensation depends on the campaign, duration and device. You always see the exact amount before approving a campaign. Payout only happens after successful completion." },
        { q: "Do I have to accept every campaign?", a: "No. You approve each campaign voluntarily and individually — after seeing brand, design, duration and compensation. Categories like gambling, alcohol or politics can be permanently excluded." },
        { q: "Will the skin damage my device?", a: "Our material requirement: residue-free removable film. We review material and surface before every campaign, and removal follows instructions. Honestly, we cannot give an absolute guarantee — if you have questions about your specific device, contact us beforehand." },
        { q: "Can I register an iPad or tablet?", a: "Yes — laptops and tablets are equally supported. Requirement: the back is visible during use, e.g. an iPad with keyboard or stand." },
        { q: "When do I get paid?", a: "Payout follows after successful completion of the campaign according to its terms — typically after the runtime ends and your photo proof is confirmed." },
        { q: "Does registering guarantee a campaign?", a: "No. Registration is free and non-binding, but does not guarantee selection. We contact you as soon as a campaign matches your profile." },
        { q: "What does a campaign cost for brands?", a: "Pricing depends on configuration, availability and material. You receive an individual quote after your request." },
        { q: "How can brands select their audience?", a: "By location, university, field of study, device type, quantity and duration — as far as matching participants are registered in the network." },
        { q: "Do I get the €5 paid out immediately?", a: "No. The €5 is first stored as Lidlink credit and paid out together with your first successfully completed paid campaign." },
        { q: "How does the referral bonus work?", a: "After registering you receive a personal referral link. If 3 valid new participants register through your link, you receive an additional €5 in Lidlink credit." },
        { q: "Do I automatically get a campaign when I register?", a: "No. Registration makes you available for matching campaigns, but does not guarantee selection or payout." },
        { q: "What happens if I haven't received a campaign yet?", a: "Your eligible credit stays in your account as pending Lidlink credit and is only paid out once a campaign is successfully completed." },
      ],
    },
    contact: {
      eyebrow: "Campaign request",
      title: "Start your first Lidlink campaign",
      sub: "Reach students where digital ads can't go. Describe your project — we will get back to you personally.",
      company: "COMPANY / BRAND",
      companyPh: "e.g. Example GmbH",
      person: "CONTACT PERSON",
      personPh: "Name, position",
      email: "BUSINESS EMAIL",
      emailPh: "contact@company.com",
      quota: "DESIRED CONFIGURATION",
      quotaPh: "e.g. 50 devices, CAU Kiel, Engineering, 4 weeks",
      message: "MESSAGE / CAMPAIGN FOCUS",
      messagePh: "Recruiting, employer branding or product launch …",
      note: "Non-binding request · Individual quote",
      submit: "SEND CAMPAIGN REQUEST",
      sending: "SENDING …",
      successTitle: "Request received.",
      successSub: "Thank you. We will review your configuration and get back to you with an individual quote. We've also sent you a confirmation by email.",
      errorGeneric: "Something went wrong. Please try again.",
      required: "Please fill in all required fields.",
      fieldRequired: "Required field",
      invalidEmail: "Invalid email address",
    },
    consent: {
      text: "We use technically necessary cookies as well as services (incl. Cloudflare, hosting) that may set cookies. Optional cookies only with your consent.",
      accept: "Accept",
      reject: "Decline",
      learn: "Privacy",
    },
    footer: {
      tagline: "Lidlink — advertising on the devices people carry.",
      platform: "Platform",
      platformLinks: ["How it works", "Calculator", "Specifications"],
      brands: "Brands",
      brandsLinks: ["For Brands", "Targeting", "Request campaign"],
      people: "Participants",
      peopleLinks: ["Register", "Compensation", "Campaign rules"],
      company: "Company",
      companyLinks: ["About Lidlink", "Contact"],
      legal: "Legal",
      legalLinks: ["Imprint", "Privacy", "Terms", "Cookie notes"],
      bottom: "Lidlink · Pilot phase Kiel",
    },
    brandsPage: {
      eyebrow: "For Brands",
      title: "Reach people in the places digital ads can't own.",
      sub: "Lidlink places your brand on the laptops and tablets of verified students — visible in lecture halls, libraries, cafés and coworking spaces.",
      cta: "Request campaign →",
      imageAlt: "Laptop in a café with people in the background",
      imageCaption: "In cafés and coworking spaces, the laptop lid is visible to others (stock photo).",
      whyTitle: "Why brands use Lidlink",
      why: [
        { t: "Precise targeting", d: "Audiences by location, university, field of study, device and duration — e.g. engineering students at CAU Kiel for 4 weeks." },
        { t: "Physical presence", d: "Your advertising exists in real everyday life — not just for seconds in a feed." },
        { t: "Proven placements", d: "Every placement is documented with a photo and confirmed by Lidlink before it counts towards the campaign." },
        { t: "Traceable reporting", d: "Photo evidence, confirmed placements, planned placement days and completion rate — no estimated impressions." },
      ],
      usecasesTitle: "Use cases",
      usecasesNote: "Every campaign is configured individually with you — these scenarios show typical applications.",
      usecases: [
        { t: "Employer Branding", d: "Reach students of specific fields directly on campus — e.g. engineering in Kiel." },
        { t: "Recruiting", d: "Address computer science or business students in their daily semester routine." },
        { t: "Product Launches", d: "Place a new app or software precisely with early adopters." },
        { t: "Local Campaigns", d: "As a local business, reach specific universities directly." },
        { t: "Events", d: "Campaigns around conferences, university fairs or semester starts." },
      ],
      measurementTitle: "Measurement — only what we can actually prove",
      measurementNote: "We don't promise estimated impressions. We deliver evidence.",
      measurement: [
        { t: "Photo evidence", d: "A photo of every applied skin, uploaded by participants.", status: "Implemented" },
        { t: "Confirmed placements", d: "Every placement is reviewed and confirmed by Lidlink.", status: "Implemented" },
        { t: "Placement days", d: "Planned value: devices × days, e.g. 100 devices × 28 days = 2,800 planned placement days.", status: "Implemented" },
        { t: "Completion rate", d: "Share of participants who complete the campaign in full.", status: "Implemented" },
        { t: "QR / landing page activity", d: "Scans and visits via campaign-specific codes and links.", status: "Optional" },
        { t: "Promo codes", d: "Conversions via exclusive campaign codes.", status: "Optional" },
      ],
    },
    peoplePage: {
      eyebrow: "For participants",
      title: "Your device can earn too.",
      sub: "Register your laptop or tablet for free and get invited to campaigns that match your profile.",
      cta: "Register your device for free →",
      controlTitle: "You stay in control. Always.",
      control: [
        { t: "Voluntary consent per campaign", d: "No campaign without your explicit, separate consent." },
        { t: "Excludable categories", d: "Alcohol, gambling, politics, crypto, dating — you decide what never goes on your device." },
        { t: "Full transparency before consent", d: "You see brand, design, duration, compensation and requirements — only then you decide." },
        { t: "Residue-free removable skin", d: "Our material requirement, reviewed before every campaign. Your device stays your device." },
      ],
      earningsTitle: "How compensation works",
      earnings: "Registration is free and does not guarantee selection. If you are selected for a campaign, you voluntarily accept it, apply the skin, prove the installation with a photo and complete the runtime. Payout follows after successful completion of the campaign.",
      honesty: "Registration does not guarantee compensation. Only a successfully completed paid campaign that you accepted is paid.",
    },
    aboutPage: {
      eyebrow: "About Lidlink",
      title: "A new advertising medium — on the devices people carry.",
      intro: "Lidlink is a two-sided advertising network: brands book campaigns on the laptops and tablets of registered participants. Participants carry a premium campaign skin for the agreed runtime and receive compensation after successful completion.",
      pilotTitle: "Pilot phase in Kiel",
      pilotText: "We deliberately start small and local: the initial focus is on students in Kiel, because audiences can be assembled precisely by university, field of study and location. Further locations will follow once the pilot runs reliably.",
      principlesTitle: "Our principles",
      principles: [
        { t: "Transparency", d: "No invented numbers, no estimated impressions. We show what we can prove." },
        { t: "Consent", d: "Participants approve every campaign individually and voluntarily — with full information upfront." },
        { t: "Honest compensation", d: "Registration is free and does not guarantee selection. Successful campaign completion is what gets paid." },
        { t: "Quality material", d: "Residue-free removable film as a fixed requirement; material and surface are reviewed before every campaign." },
      ],
      contactTitle: "Contact",
      contactText: "Questions about the platform, campaigns or participation? Write to us via the form — we reply personally.",
      contactCta: "Get in touch →",
      legalNote: "You can find the legal notice and details in the imprint.",
    },
    proofPage: {
      eyebrow: "INSTALLATION PROOF",
      title: "Confirm your installation",
      hi: "Hi",
      intro: "Upload a photo of your device with the campaign skin applied — lid and skin clearly visible.",
      device: "DEVICE",
      statusLabel: "CAMPAIGN STATUS",
      uploadLabel: "CHOOSE OR TAKE A PHOTO",
      uploadHint: "JPEG, PNG or WebP · max 10 MB",
      submit: "UPLOAD PROOF →",
      uploading: "UPLOADING …",
      successTitle: "Proof received.",
      successSub: "We will review the installation and confirm it. Your payout follows after the campaign ends successfully.",
      verifiedBadge: "✓ Installation verified",
      pendingBadge: "Proof submitted — under review",
      alreadyTitle: "Your proof is already on file.",
      notFound: "This link is invalid or has expired.",
      errorGeneric: "Upload failed. Please try again.",
      errorType: "Please choose an image file (JPEG, PNG, WebP).",
      changePhoto: "Upload a different photo",
    },
    legal: {
      note: "Hinweis: Die rechtlichen Informationen werden auf Deutsch bereitgestellt. / Legal information is provided in German.",
      back: "← Back to homepage",
    },
    login: {
      title: "Admin Login",
      sub: "Access to Lidlink administration.",
      email: "EMAIL",
      password: "PASSWORD",
      submit: "SIGN IN",
      error: "Login failed. Please check your credentials.",
    },
    admin: {
      title: "Lidlink Admin",
      registrations: "Registrations",
      requests: "Campaign requests",
      logout: "Sign out",
      empty: "No entries yet.",
      status: "Status",
      date: "Date",
      loading: "Loading …",
    },
  },
};
